<div>
  <div class="resource-header">
    <h2 class="list-header">
      {{ title }}
    </h2>
    <a *ngIf="viewAllRoute" [routerLink]="[viewAllRoute]" class="view-all-link">
      <span class="view-all-text"
        >{{ viewAllText || ('View All' | i18nextEager) }}
      </span>
      <span>{{ title }}</span>
      <em class="far fa-arrow-right"></em>
    </a>
  </div>

  <div class="bs-card-deck">
    <a
      href="javascript:void(0)"
      class="bs-card"
      (click)="onResourceClick(resource)"
      *ngFor="let resource of resources"
    >
      <img
        class="bs-card-img-top"
        [src]="resource.imgUrl"
        [alt]="resource.resourceName"
      />
      <div class="bs-card-body">
        <h5 class="bs-card-title" dir="{{ dispLanguageDirection }}">
          {{ resource.resourceName }}
        </h5>
        <p class="bs-card-text" dir="{{ dispLanguageDirection }}">
          {{ resource.tagline }}
        </p>
      </div>
    </a>
  </div>
</div>
